import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Yii } from "../../../../interfaces/Yii";
import { CarModel } from "../../../../models/car/car.model";

class WordingClass {
    public readonly modalTitle: string = Yii.t('wui-shared-js', 'Contacts');
    public readonly dropOff: string = Yii.t('wui-shared-js', 'DropOff');
    public readonly pickUp: string = Yii.t('wui-shared-js', 'PickUp');
    public readonly closeBtn: string = Yii.t('wui-shared-js', 'Fermer');
}

@Component({
    selector: 'block-car-modal-contact',
    template: `
        <modal [showModal]="showModal" (onClose)="isClosed()">
            <ng-container class="modal-header-content">
                <h1 class="title">{{wording.modalTitle}}</h1>
                <btn type="actionUndo" label="{{wording.closeBtn}}" (onClick)="isClosed()"></btn>
            </ng-container>
            <ng-container class="modal-body-content">
                <div class="car-row">
                    <div class="card-marge-inside car-col">
                        <strong>{{wording.pickUp}}</strong>
                        <pick-car-contact [booking]="booking" [type]="'pickup'" [isShowIcon]="true" [showPlace]="true"
                                          [showAddress]="true"></pick-car-contact>
                    </div>
                    <div class="card-marge-inside car-col">
                        <strong>{{wording.dropOff}}</strong>
                        <pick-car-contact [booking]="booking" [type]="'dropOff'" [isShowIcon]="true" [showPlace]="true"
                                          [showAddress]="true"></pick-car-contact>
                    </div>
                </div>
            </ng-container>
        </modal>
    `,

    styles: [`
        :host {
            color: #0E0E0E;
        }

        strong {
            margin-bottom: auto;
        }`
    ],
    styleUrls: ['../style.scss']
})

export class BlockCarModalContactComponent implements OnInit {
    @Input()
    public booking: CarModel;

    @Input()
    public showModal: boolean = false;

    @Output()
    public showModalEventEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

    public readonly wording: WordingClass = new WordingClass();

    constructor() {
    }

    ngOnInit(): void {
    }

    public isClosed(): void {
        this.showModal = false;
        this.showModalEventEmit.emit(this.showModal);
    }
}
